import React from 'react';
import styled from 'styled-components';

const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SectionLabel = styled.h2`
  margin: 0;
  font-size: 40px;
  font-family: 'JetBrains Mono', monospace;
  font-weight: 700;
  display: inline-block;
  width: fit-content;
  background: linear-gradient(45deg, #f97316, #facc15);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;

  body.dark & {
    background: linear-gradient(30deg, #ff4190, #92c5ff);
    background-clip: text;
    -webkit-background-clip: text;
  }
`;

const Bio = styled.p`
  margin: 0;
  font-size: 18px;
  font-family: 'JetBrains Mono', monospace;
  font-weight: 400;
  color: var(--text);
  line-height: 1.75;
  max-width: 680px;
`;

const Links = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
`;

const Divider = styled.span`
  font-family: 'JetBrains Mono', monospace;
  color: var(--text);
  opacity: 0.2;
  font-size: 15px;
`;

const Link = styled.a`
  font-size: 15px;
  font-family: 'JetBrains Mono', monospace;
  font-weight: 500;
  text-decoration: none;
  letter-spacing: 0.06em;
  color: var(--text);
  opacity: 0.75;
  transition: opacity 0.2s ease, background-position 0.3s ease;
  background: linear-gradient(90deg, #34d399, #22d3ee);
  background-clip: text;
  -webkit-background-clip: text;
  background-size: 200%;
  background-position: 100%;

  body.dark & {
    background: linear-gradient(90deg, #00ffa3, #00d4ff);
    background-clip: text;
    -webkit-background-clip: text;
    background-size: 200%;
    background-position: 100%;
  }

  &:hover {
    opacity: 1;
    color: transparent;
    background-position: 0%;
  }
`;

const AboutMe = () => {
  return (
    <Container>
      <SectionLabel>About Me</SectionLabel>
      <Bio>
        Software engineer with a background spanning computer systems, graphics, and full-stack
        development — from parallel ray tracers and Unix kernels to real-time video platforms and
        multi-tenant APIs. I'm drawn to problems at the boundary of systems and interfaces,
        especially anything touching rendering, geometry, or real-time data.
      </Bio>
      <Bio>
        Outside of work I'm into creative coding — p5.js sketches, shaders, and anything that
        blurs the line between programming and art. Competitive coding on the side.
      </Bio>
      <Links>
        <Link href="https://linkedin.com/in/hey-its-suvi" target="_blank" rel="noreferrer">linkedin</Link>
        <Link href="https://github.com/hey-its-suvi" target="_blank" rel="noreferrer">github</Link>
        <Link href="https://leetcode.com/u/hey_its_suvi/" target="_blank" rel="noreferrer">leetcode</Link>
        <Divider>|</Divider>
        <Link href="/resume.pdf" target="_blank" rel="noreferrer">resume</Link>
      </Links>
    </Container>
  );
};

export default AboutMe;
